import { ThemeProvider as NextThemesProvider, useTheme } from 'next-themes';

/**
 * next-themes is not Next-specific — it is the provider shadcn's own components
 * (Toaster included) expect, and it handles the parts that are easy to get
 * wrong: reading the OS preference, syncing across tabs, and writing the class
 * onto <html> before first paint so a dark-mode user never sees a white flash.
 */
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      storageKey="epic-hub:theme"
    >
      {children}
    </NextThemesProvider>
  );
}

export { useTheme };
